import { route }   from 'ziggy-js';
import { usePage } from "@inertiajs/vue3";
import type { App } from "vue";

type TypeParameters = {
    [key : string] : string | number | any[]
};

/**
 * @global
 * @function localeRoute
 * @param routeName {string}
 * @param parameters {TypeParameters}
 */
export const localeRoute = (routeName : string, parameters : TypeParameters = {}) : string => {
    const locale = usePage().props?.locale;

    parameters.locale = typeof locale == 'string' ? locale : 'ua';

    return route(routeName, parameters);
};

export default {
    install(app : App) : void {
        app.config.globalProperties.localeRoute = localeRoute;
    },
};
